import { Component, ElementRef, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import {DataService} from '../data.service';
import {Router, ActivatedRoute} from '@angular/router';
import { CountryService } from '../country.service';
import {Constants} from '../constants';
import {NgForm} from '@angular/forms';

declare var $: any;
declare var Nanobar: any;
declare var google: any;
declare var toastr: any;

@Component({
  selector: 'app-withdraw',
  templateUrl: './withdraw.component.html',
  styleUrls: ['./withdraw.component.css']
})
export class WithdrawComponent implements OnInit {
  priceIconForSingle = Constants.iconForSinglePrice;
  priceIconForDouble = Constants.iconForDoublePrice;
  nao = new Nanobar();
  available_balance: any;
  getWithDrawData: any;
  account_number = '';
  processWithdrawSuccess: any;
  processWithdrawMessage: any;
  status = 0;
  transactionDetailData: any;
  transactionDetailDataSuccess: any;
  withdrawType = '6';
  withdrawLimit = 200;
  searchWithdraw = '';
  clearTimeout: any;
  batchArray = new Array();
  editBatchArray = new Array();
  batchBtn = false;
  createBatchData: any;
  batchMessage: any;
  batchData: any;
  batchRemoveSuccess: any;
  batchCompleteProcess: any;
  downloadCSVData: any;
  noDataFound = false;
  paginatedDataWithdraw: any;
  withdrawPageCount = 0;
  withdrawLastPage = true;
  paginatedDataBatch: any;
  batchPageCount = 0;
  batchLastPage = true;
  disabledClick: any;
 constructor(private route: ActivatedRoute, private dataService: DataService, private router: Router,  private cs: CountryService, private chRef: ChangeDetectorRef) { }
 setStatusWhileChangingTab(status) {
   this.status = status;
   this.withdrawType = '6';
   this.getWithDrawRequestsFunction();
 }
 getWithDrawRequestsFunction() {
   this.withdrawPageCount = 0;
   this.getWithDrawData = [];
   this.downloadCSVData = [];
   this.noDataFound = true;
   clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
    var type = parseInt(this.withdrawType, 10);
    this.nao.go(30);
    this.dataService.getWithDrawRequests(window.localStorage.getItem('token'), this.status, type, this.searchWithdraw).subscribe(
      (data) => {
        this.nao.go(100);
        this.noDataFound = false;
        this.getWithDrawData = data;
        this.withdrawLastPage = this.getWithDrawData.last_page;
        this.withdrawPageCount++;
        this.getWithDrawData = this.getWithDrawData.items;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
    }, 1000);
  }
  getWithDrawRequestsByPage() {
   var type = parseInt(this.withdrawType, 10);
    this.nao.go(30);
    console.log('login data');
    this.dataService.getWithDrawRequestsByPage(window.localStorage.getItem('token'), this.status, type, this.searchWithdraw, this.withdrawPageCount).subscribe(
      (data) => {
        this.nao.go(100);
        this.paginatedDataWithdraw = data;
        // this.limit = this.paginatedData.limit;
        this.withdrawLastPage = this.paginatedDataWithdraw.last_page;
        this.withdrawPageCount++;
        this.paginatedDataWithdraw = this.paginatedDataWithdraw.items;
        for (var i = 0; i < this.paginatedDataWithdraw.length; i++) {
          this.getWithDrawData.push(this.paginatedDataWithdraw[i]);
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  processWithDrawRequestFunction(id, tab_name) {
    // this.nao.go(30);
    this.dataService.processWithDrawRequest(window.localStorage.getItem('token'), id).subscribe(
      (data) => {
        // this.nao.go(100);
        this.processWithdrawSuccess = data;
        this.processWithdrawMessage = this.processWithdrawSuccess.message;
        this.processWithdrawSuccess = this.processWithdrawSuccess.success;
        if (this.processWithdrawSuccess === true) {
          $('.clear').removeClass('active');
          // if (tab_name === 'new') {
          // $('#2').addClass('active');
          // $('#inProcess').addClass('active');
          // $('#inProcess').addClass('in');
          // this.status = 2;
          // this.getWithDrawRequestsFunction();
          // }
          if (tab_name === 'inProcess') {
          $('#3').addClass('active');
          $('#complete').addClass('active');
          $('#complete').addClass('in');
          this.status = 3;
          this.getWithDrawRequestsFunction();
          }
          toastr.success(this.processWithdrawMessage);
        } else {
          toastr.error(this.processWithdrawMessage);
        }
      },
      (error) => {
        // this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  transactionDetailPopOpen(id) {
    this.nao.go(30);
    this.dataService.getTransactionDetailsOnWithdraw(window.localStorage.getItem('token'), id).subscribe(
      // , this.type, this.status, this.business_id
      (data) => {
        this.nao.go(100);
        this.transactionDetailData = data;
        this.transactionDetailDataSuccess = this.transactionDetailData.success;
        this.transactionDetailData = this.transactionDetailData.business_activity_dictionary;
        if (this.transactionDetailDataSuccess === true) {
        $('#transactionDetailPop').modal('show');
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  clearSearch() {
    this.searchWithdraw = '';
    this.getWithDrawRequestsFunction();
  }
  // rtgsPopOpen() {
  //  $('#rtgsPop').modal('show');
  // }
   batchFunction(id, index) {
    setTimeout(() => { this.chRef.detectChanges(); }, 100);
    if ($('#chk' + index).prop('checked') === true) {
    for (var i = 0; i < this.getWithDrawData.length; i++) {
      if (this.getWithDrawData[i].id === id) {
        this.batchArray.push({
          id: id
        });
      }
    }
    console.log('this.getWithDrawData[index]', this.getWithDrawData[index]);
    this.downloadCSVData.push({
    id: this.getWithDrawData[index].id,
     account_title: this.getWithDrawData[index].account_title,
     routing_number: this.getWithDrawData[index].routing_number,
     account_number: this.getWithDrawData[index].account_number,
     net_amount: this.getWithDrawData[index].net_amount,
   });
    // this.downloadCSVData.push(this.getWithDrawData[index]);
    // console.log('this.batchArray true', this.batchArray);
    console.log('this.downloadCSVData true', this.downloadCSVData);
    } else {
      for (var i = 0; i < this.batchArray.length; i++) {
      if (this.batchArray[i].id === id) {
        // console.log('id', id);
        // console.log('this.batchArray[i]', this.batchArray[i]);
        this.batchArray.splice(i, 1);
      }
    }
    for (var j = 0; j < this.downloadCSVData.length; j++) {
      if (this.downloadCSVData[j].id === this.getWithDrawData[index].id) {
        this.downloadCSVData.splice(j, 1);
      }
    }
      console.log('this.downloadCSVData false', this.downloadCSVData);
    }
    // console.log('this.batchArray.length', this.batchArray.length);
    // if (this.downloadCSVData.length === 0) {
    //   this.downloadCSVData = this.getWithDrawData;
    // }
    if (this.batchArray.length > 0) {
    this.batchBtn = true;
    } else {
      this.batchBtn = false;
    }
    // console.log('this.downloadCSVData false', this.downloadCSVData);
  }
   batchAllFunction() {
    setTimeout(() => { this.chRef.detectChanges(); }, 100);
    if ($('#checkAllNew').prop('checked') === true) {
      this.getWithDrawData.forEach((data, index) => {
        $('#chk' + index).prop('checked', true)
        this.batchArray.push({
          id: data.id
        });
        this.downloadCSVData.push({
        id: data.id,
         account_title: data.account_title,
         routing_number: data.routing_number,
         account_number: data.account_number,
         net_amount: data.net_amount,
       });
      });

    // this.downloadCSVData.push(this.getWithDrawData[index]);
    // console.log('this.batchArray true', this.batchArray);
    console.log('this.downloadCSVData true', this.downloadCSVData);
    } else {
      this.batchArray = [];
      this.downloadCSVData = [];
      this.getWithDrawData.forEach((data, index) => {
        $('#chk' + index).prop('checked', false);
      });
    }
    if (this.batchArray.length > 0) {
    this.batchBtn = true;
    } else {
      this.batchBtn = false;
    }
  }
  createBatchfunction() {
   this.disabledClick = true;
    this.chRef.detectChanges();
    this.nao.go(30);
    console.log('login data');
    this.dataService.createBatch(window.localStorage.getItem('token'), this.batchArray).subscribe(
      (data) => {
        this.nao.go(100);
        this.createBatchData = data;
        this.batchMessage = this.createBatchData.message;
        this.createBatchData = this.createBatchData.success;
        if (this.createBatchData === true) {
         toastr.success(this.batchMessage);
         this.batchBtn = false;
         this.batchArray = [];
         this.chRef.detectChanges();
         $('.clearChk').prop('checked', false);
         $('.clear').removeClass('active');
         setTimeout(() => {
         $('#2').addClass('active');
          $('#inProcess').addClass('active');
          $('#inProcess').addClass('in');
          // this.status = 2;
          this.getWithDrawRequestsFunction();
          this.getBatchesOfWithdrawRequestsFunction();
          this.chRef.detectChanges();
          this.disabledClick = false;
          }, 1000);
        } else {
          toastr.error(this.batchMessage);
          this.disabledClick = false;
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  getBatchesOfWithdrawRequestsFunction() {
    this.chRef.detectChanges();
    this.noDataFound = true;
    // this.nao.go(30);
    console.log('login data');
    this.dataService.getBatchesOfWithdrawRequests(window.localStorage.getItem('token')).subscribe(
      (data) => {
        // this.nao.go(100);
        this.noDataFound = false;
        this.batchData = data;
        this.batchLastPage = this.batchData.last_page;
        this.batchPageCount++;
        this.batchData = this.batchData.items;
      },
      (error) => {
        // this.nao.go(100);
        console.log('error', error);
      }
    );
  }
   getBatchesOfWithdrawRequestsByPageFunction() {
    this.nao.go(30);
    console.log('login data');
    this.dataService.getBatchesOfWithdrawRequestsByPage(window.localStorage.getItem('token'), this.batchPageCount).subscribe(
      (data) => {
        this.nao.go(100);
        this.paginatedDataBatch = data;
        // this.limit = this.paginatedData.limit;
        this.batchLastPage = this.paginatedDataBatch.last_page;
        this.batchPageCount++;
        this.paginatedDataBatch = this.paginatedDataBatch.items;
        for (var i = 0; i < this.paginatedDataBatch.length; i++) {
          this.batchData.push(this.paginatedDataBatch[i]);
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  editWithdrawRequestBatchFunction(batchId, listObj, id, fullBatchRemove) {
    this.chRef.detectChanges();
    this.editBatchArray = [];
    if (fullBatchRemove === true) {
      for (let i = 0; i < listObj.length; i++) {
          this.editBatchArray.push({
            id: listObj[i].id,
            is_remove: true,
          });
      }
    } else {
      console.log('batchId, listObj', batchId, listObj);
      for (let i = 0; i < listObj.length; i++) {
        if (listObj[i].id === id) {
          this.editBatchArray.push({
            id: listObj[i].id,
            is_remove: true,
          });
        } else {
          this.editBatchArray.push({
            id: listObj[i].id,
            is_remove: false,
          });
        }
      }
    }
    this.nao.go(30);
    console.log('login data');
    this.dataService.editWithdrawRequestBatch(window.localStorage.getItem('token'), batchId, this.editBatchArray).subscribe(
      (data) => {
        this.nao.go(100);
        this.batchRemoveSuccess = data;
        if (this.batchRemoveSuccess.success === true) {
        this.getBatchesOfWithdrawRequestsFunction();
        toastr.success(this.batchRemoveSuccess.message);
        } else {
          toastr.error(this.batchRemoveSuccess.message);
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  processBatchOfWithDrawRequestsFunction(batchId) {
    this.chRef.detectChanges();
    // this.nao.go(30);
    console.log('login data');
    this.dataService.processBatchOfWithDrawRequests(window.localStorage.getItem('token'), batchId).subscribe(
      (data) => {
        this.batchCompleteProcess = data;
        if (this.batchCompleteProcess.success === true) {
          toastr.success(this.batchCompleteProcess.message);
          $('.clearChk').prop('checked', false);
          $('.clear').removeClass('active');
          $('#3').addClass('active');
          $('#complete').addClass('active');
          $('#complete').addClass('in');
          this.status = 3;
          this.getWithDrawRequestsFunction();
        } else {
          toastr.error(this.batchCompleteProcess.message);
        }
      },
      (error) => {
        // this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  csvArrayFunction(index) {
    setTimeout(() => { this.chRef.detectChanges(); }, 100);
    if ($('#chkComplete' + index).prop('checked') === true) {
      // this.downloadCSVData.push(this.getWithDrawData[index]);
      this.downloadCSVData.push({
        id: this.getWithDrawData[index].id,
       account_title: this.getWithDrawData[index].account_title,
       routing_number: this.getWithDrawData[index].routing_number,
       account_number: this.getWithDrawData[index].account_number,
       net_amount: this.getWithDrawData[index].net_amount,
     });
      console.log('this.downloadCSVData true', index, this.downloadCSVData);
    } else {
      // this.downloadCSVData.splice(index, 1);
      for (var j = 0; j < this.downloadCSVData.length; j++) {
      if (this.downloadCSVData[j].id === this.getWithDrawData[index].id) {
        this.downloadCSVData.splice(j, 1);
      }
    }
      console.log('this.downloadCSVData false', index, this.downloadCSVData);

    }
  }
  csvGenerateSales() {
   var chkFull = false;
   if (this.downloadCSVData.length === 0) {
     // this.downloadCSVData = this.getWithDrawData;
     chkFull = true;
     console.log('in CSV full array', this.getWithDrawData);
     for (let i = 0; i < this.getWithDrawData.length; i++) {
    this.downloadCSVData.push({
      id: this.getWithDrawData[i].id,
     account_title: this.getWithDrawData[i].account_title,
     routing_number: this.getWithDrawData[i].routing_number,
     account_number: this.getWithDrawData[i].account_number,
     net_amount: this.getWithDrawData[i].net_amount,
   });
   }
   }
   var arrayToPass = new Array();
   for (let i = 0; i < this.downloadCSVData.length; i++) {
    arrayToPass.push({
     'Sr.No': i + 1,
     'Account Title': this.downloadCSVData[i].account_title,
     'Routing No': this.downloadCSVData[i].routing_number,
     'Account No': this.downloadCSVData[i].account_number,
     'Net Amount': '$' + this.downloadCSVData[i].net_amount,
   });
   }
   if (chkFull === true) {
     console.log('in chk csv full or not');
    this.downloadCSVData = [];
   }
   var csvData = this.ConvertToCSV(arrayToPass);
    var a = document.createElement("a");
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    var blob = new Blob([csvData], { type: 'text/csv' });
    var url= window.URL.createObjectURL(blob);
    a.href = url;
    a.download = 'withdraw.csv';
    a.click();
  }
   ConvertToCSV(objArray) {
            var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
            var str = '';
            var row = '';

            for (var index in objArray[0]) {
                // Now convert each value to string and comma-separated
                row += index + ',';
            }
            row = row.slice(0, -1);
            // append Label row with line break
            str += row + '\r\n';

            for (var i = 0; i < array.length; i++) {
                var line = '';
                for (var index in array[i]) {
                    if (line != '') line += ',';

                    line += array[i][index];
                }
                str += line + '\r\n';
            }
            return str;
        }
  csvGenerateBatch(array) {
   var arrayToPass = new Array();
   for (let i = 0; i < array.length; i++) {
    arrayToPass.push({
     'Sr.No': i + 1,
     'Account Title': array[i].account_title,
     'Routing No': array[i].routing_number,
     'Account No': array[i].account_number,
     'Net Amount': '$' + array[i].net_amount,
   });
   }
   var csvData = this.ConvertToCSVBatch(arrayToPass);
    var a = document.createElement("a");
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    var blob = new Blob([csvData], { type: 'text/csv' });
    var url= window.URL.createObjectURL(blob);
    a.href = url;
    a.download = 'withdraw.csv';
    a.click();
  }
   ConvertToCSVBatch(objArray) {
            var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
            var str = '';
            var row = '';

            for (var index in objArray[0]) {
                // Now convert each value to string and comma-separated
                row += index + ',';
            }
            row = row.slice(0, -1);
            // append Label row with line break
            str += row + '\r\n';

            for (var i = 0; i < array.length; i++) {
                var line = '';
                for (var index in array[i]) {
                    if (line != '') line += ',';

                    line += array[i][index];
                }
                str += line + '\r\n';
            }
            return str;
        }
  ngOnInit() {
    // $(document).ready(function () {
    //   $(".tbtn").click(function () {
    //       $(this).parents(".custom-table").find(".toggler1").removeClass("toggler1");
    //       $(this).parents("tbody").find(".toggler").addClass("toggler1");
    //       $(this).parents(".custom-table").find(".fa-minus-circle").removeClass("fa-minus-circle");
    //       $(this).parents("tbody").find(".fa-plus-circle").addClass("fa-minus-circle");
    //   });
    // });
    this.getWithDrawRequestsFunction();
   $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#withdraw').css('color', '#d77229');
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('#sidebar').css('display', 'block');
  }

}



// WEBPACK FOOTER //
// ./src/app/withdraw/withdraw.component.ts